let stripeGatewayService = ($window, externalScriptService) => {

  const options = {
    style: {
      base: {
        fontSize: '16px',
      }
    }
  };

  let isMounted = false;
  let createToken;
  let createAction;
  let createPaymentRequestButton;

  const load = () => externalScriptService.load('https://js.stripe.com/v3/');

  const mount = gatewayDetails => {
    if (!isMounted) {
      isMounted = true;
      const stripe = $window.Stripe(gatewayDetails.key);
      const element = stripe.elements();

      const cardInput = element.create('card', options);
      cardInput.mount('#payment-details');

      createToken = () => {
        const billingName = `${$window.document.getElementById('firstName').value} ${$window.document.getElementById('lastName').value}`;
        const billingEmail = $window.document.getElementById('emailAddress').value;

        return stripe.createPaymentMethod('card', cardInput, {
          billing_details: {
            name: billingName,
            email: billingEmail
          }
        })
          .then(response => {
            if (response.error) {
              throw response.error;
            }

            return response.paymentMethod;
          });
      };

      createAction = (clientSecret) => {
        return stripe.handleCardAction(clientSecret)
          .then(response => {
            if (response.error) {
              throw response.error;
            }

            return response;
          });
      };

      createPaymentRequestButton = requestConfig => {
        const paymentRequest = stripe.paymentRequest({
          country: requestConfig.country,
          currency: requestConfig.currency,
          total: {
            label: 'Order total',
            amount: requestConfig.amount,
          },
          requestPayerName: true,
          requestPayerEmail: true,
          requestPayerPhone: true,
        });

        let prButton = element.getElement('paymentRequestButton');
        if (!prButton) {
          prButton = element.create('paymentRequestButton', {
            paymentRequest: paymentRequest
          });
        }

        return paymentRequest.canMakePayment()
          .then(function (result) {
            if (result) {
              prButton.mount('#payment-request-button');
              $window.document.getElementsByClassName('c-payment__request')[0].style.display = 'block';
              return paymentRequest;
            }
          });
      };
    }

    return Promise.resolve({
      createToken: createToken,
      createAction: createAction,
      createPaymentRequestButton: createPaymentRequestButton
    });
  };

  return {
    load,
    mount
  };
};

stripeGatewayService.$inject = [ '$window', 'externalScriptService' ];

export default stripeGatewayService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/services/stripe.gateway.service.js